import { Button } from '@cian/ui-kit';

interface IButtonLinkProps {
  children: string;
  onClick: VoidFunction;
}

export const ButtonLink: React.FC<IButtonLinkProps> = ({ children, onClick }) => {
  return (
    <Button size="L" fullWidth onClick={onClick}>
      {children}
    </Button>
  );
};
